import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from '../__root';

const resetPasswordSearchSchema = z.object({
  token: z.string().optional(),
});

/**
 * Deliberately NOT behind `requireGuest`: the reset link arrives by email and is
 * routinely opened in a browser that still holds a live session. Bouncing that
 * user to the dashboard would make the link look broken — and the reset itself
 * revokes every session anyway.
 */
export const resetPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/auth/reset-password',
  validateSearch: resetPasswordSearchSchema,
  component: lazyRouteComponent(
    () => import('@/features/auth/ResetPasswordPage'),
    'ResetPasswordPage',
  ),
});
